import { useState, useEffect } from "react";
import { ethers } from "ethers";

export default function ChainInfo() {
  const [account, setAccount] = useState(null);
  const [chainId, setChainId] = useState(null);
  const [blockNumber, setBlockNumber] = useState(null);
  const [error, setError] = useState(null);

  const connectWallet = async () => {
    if (window.ethereum) {
      try {
        // 1. Connect to window.ethereum
        const provider = new ethers.BrowserProvider(window.ethereum);
        
        // 2. Request account access
        const signer = await provider.getSigner();
        const address = await signer.getAddress();
        
        // 3. Get Network info
        const network = await provider.getNetwork();
        const chainIdBigInt = network.chainId;
        
        // 4. Get Block Number
        const block = await provider.getBlockNumber();

        // Update State
        setAccount(address);
        setChainId(chainIdBigInt.toString());
        setBlockNumber(block);

        // 5. Sepolia Validation (Sepolia Chain ID is 11155111)
        if (chainIdBigInt.toString() !== "11155111") {
          setError("You are not connected to the Sepolia Network.");
        } else {
          setError(null);
        }

      } catch (err) {
        console.error(err);
        setError("Failed to connect wallet.");
      }
    } else {
      setError("MetaMask is not installed.");
    }
  };

  // Auto-connect on load (optional, but good for UX)
  useEffect(() => {
    connectWallet();
    
    // Listen for chain changes to update state immediately
    if(window.ethereum) {
        window.ethereum.on('chainChanged', () => window.location.reload());
        window.ethereum.on('accountsChanged', () => window.location.reload());
    }
  }, []);

  // Error Page View
  if (error) {
    return (
      <div style={{ backgroundColor: "#ffcccc", padding: "20px", borderRadius: "8px" }}>
        <h2 style={{ color: "red" }}>Error: Wrong Network</h2>
        <p>{error}</p>
        <p>Please open MetaMask and switch to <b>Sepolia</b>.</p>
        <button onClick={connectWallet}>Retry Connection</button>
      </div>
    );
  }

  return (
    <div>
      <h1>Chain Info</h1>
      {!account ? (
        <button onClick={connectWallet}>Connect MetaMask</button>
      ) : (
        <div style={{ border: "1px solid #ddd", padding: "20px", borderRadius: "8px" }}>
          <p><strong>User Address:</strong> {account}</p>
          <p><strong>Chain ID:</strong> {chainId}</p>
          <p><strong>Last Block Number:</strong> {blockNumber}</p>
          <div style={{ marginTop: "10px", color: "green" }}>
            ✅ Connected to Sepolia
          </div>
        </div>
      )}
    </div>
  );
}